import { useEffect, useState } from "react";
import useFirestore from "../common/useFirestore";

function useBoard(){
    const {readFirestoreWithSort, readFirestoreWithQuery} = useFirestore();
    const [boardList, setBoardList] = useState([]);
    const [category, setCategory] = useState("전체");

    useEffect(() => {
        getBoardList();
        // eslint-disable-next-line
    }, [category])

    const getBoardList = async() => {
        let board_list = null;
        if(category === "전체"){
            board_list = await readFirestoreWithSort("Inquiry", {name:"register_at", direction:"desc"}).then(res => {
                const list = [];
                for(let i = 0; i < res.size; i++){
                    list.push({id:res.docs[i].id, ...res.docs[i].data()});
                }
                return list;
            })
        }else{
            board_list = await readFirestoreWithQuery("Inquiry", {field:"category", operator:"==", data:category}).then(res => {
                const list = [];
                for(let i = 0; i < res.size; i++){
                    list.push({id:res.docs[i].id, ...res.docs[i].data()});
                }
                return list;
            })
        }
        setBoardList(board_list);
    }

    const onSelectChangeHandler = (e) => {
        setCategory(e.target.value);
    }

    return {boardList, category, onSelectChangeHandler}
}

export default useBoard;